export default __webpack_public_path__ + "static/media/SearchTalent.d4fe29da.svg";